import { call, put, takeLatest } from "redux-saga/effects";
import { API } from "../../../api/api";
import { hallsAPI } from "../api/api";
import { HallsActionTypes } from "../actions/actionTypes";

function* getServerLicense(action) {
    try {
        const license = yield call(() =>
            hallsAPI.getServerLicense({ serverId: action.payload.serverId })
        );

        yield put({
            type: HallsActionTypes.GET_SERVER_LICENSE_SUCCESS,
            payload: license.data
        });
    } catch (e) {
        if (
            e.response &&
            e.response.data &&
            e.response.data.hasOwnProperty("code") &&
            e.response.data.code == 14007
        ) {
            yield put({
                type: HallsActionTypes.GET_SERVER_LICENSE_SUCCESS,
                payload: null
            });
        } else {
            API.handleError(e.response, "Error getting server license.");

            yield put({
                type: HallsActionTypes.GET_SERVER_LICENSE_FAIL,
                message: e.message
            });
        }
    }
}

export function* getServerLicenseWatcher() {
    yield takeLatest(HallsActionTypes.GET_SERVER_LICENSE, getServerLicense);
}
